<template>
  <div class="home-location">
    <!-- 首页 -->
    <router-link to="/index">
      <span class="iconfont icon-home"> </span>
      <span>首页</span>
    </router-link>

    <!-- 菜单循环  -->
    <template v-for="(item, index) in curNavList">
      <router-link :key="index" :to="item.path">
        <span class="iconfont icon-arrow-right"></span>
        <span v-text="item.name"></span>
      </router-link>
    </template>

    <!-- 详情页 -->
    <template v-if="detailInfo && (detailInfo.name || detailInfo.title)">
      <span class="iconfont icon-arrow-right"></span>
      <span class="detail-name" :title="detailInfo.name || detailInfo.title" v-text="detailInfo.name || detailInfo.title"></span>
    </template>
  </div>
</template>

<script>
import colums from '../../colums/colums.js';
export default {
  name: 'crumbs',
  props: {
    detailInfo: Object,
    custNav: Array
  },
  data() {
    return {
      cate: '',
      curNavList: [],
      firstNav: {},
      nav: colums.navlist,
      jmkcate: colums.jmkcate,
      wxkcate: colums.literatureCate,
      zpkcate: colums.exhibitCate
    }
  },
  mounted() {
    let { cate } = this.$route.query
    this.cate = cate
    this.initPage()
  },
  watch: {
    detailInfo: {
      handler(newv) {
        if (newv) {
          this.initPage()
        }
      },
      immediate: true
    }
  },
  methods: {
    initPage() {
      let path = this.$route.path
      if (path.indexOf('/book/') != -1) {
        path = '/literature'
      } else if (path.indexOf('/preview/') != -1) {
        path = '/program'
      } else if (path.indexOf('/preview-news/') != -1) {
        path = '/news'
      } else if (path.indexOf('/thematic/') != -1) {
        path = '/activity'
        this.cate = 2
      }
      let cate = this.cate
      let newNav = [];
      if (this.custNav && this.custNav.length > 0) {
        this.curNavList = this.custNav
        this.firstNav = this.custNav[0]
      } else {
        let navs = this.nav.find(v => path.indexOf(v.path) != -1)
        if (navs) {
          this.firstNav = {
            name: navs.name,
            path: navs.path
          }
          newNav.push(this.firstNav)
        }
        let ctList = []
        const detailInfo = this.detailInfo
        switch (navs && navs.path) {
          case '/program':
            ctList = this.jmkcate
            detailInfo && (cate = detailInfo.type_id)
            break
          case '/exhibit':
            ctList = this.zpkcate
            detailInfo && (cate = detailInfo.category)
            break
          case '/literature':
            ctList = this.wxkcate
            detailInfo && (cate = detailInfo.category)
            break
        }
        this.cate = cate

        if (ctList && ctList.length) {
          let subs = ctList.find(v => v.id == cate)
          if (subs) {
            const obj = {
              name: subs.name,
              path: subs.path + `?cate=${cate}`
            }
            newNav.push(obj)
          }
        }

        //如果主栏目里面没有配置，则直接通过title取内容
        if (newNav.length == 0) {
          try {
            let title = this.$route.meta.title.split('-')[0];
            let path = this.$route.path.split('/')
            // console.log(path[1])
            let obj = {
              name: title,
              path: '/' + path[1],
              eName: this.$route.name
            }
            this.firstNav = obj;
            newNav.push(obj);
          } catch (err) { }
        }
        this.curNavList = newNav;
      }
    },
  }
}
</script>